import { Input, InputNumber } from "antd";
import { forwardRef, useRef } from "react";

const FocusSafeInput = forwardRef(
  ({ type = "text", ...props }, externalRef) => {
    const inputRef = useRef(null);

    const forceFocus = (e) => {
      e.preventDefault();
      e.stopPropagation();
      // Let Select finish stealing focus, then steal it back
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if (type === "number") {
            inputRef.current?.focus?.();
          } else {
            inputRef.current?.input?.focus?.();
          }
        });
      });
    };

    if (type === "number") {
      return (
        <InputNumber
          {...props}
          ref={(node) => {
            inputRef.current = node;
            if (externalRef) {
              if (typeof externalRef === 'function') {
                externalRef(node);
              } else {
                externalRef.current = node;
              }
            }
          }}
          onMouseDown={forceFocus}
          onClick={(e) => e.stopPropagation()}
          style={{ width: "100%", ...props.style }}
        />
      );
    }

    return (
      <Input
        {...props}
        ref={(node) => {
          inputRef.current = node;
          if (externalRef) {
            if (typeof externalRef === 'function') {
              externalRef(node);
            } else {
              externalRef.current = node;
            }
          }
        }}
        onMouseDown={forceFocus}
        onClick={(e) => e.stopPropagation()}
      />
    );
  }
);

FocusSafeInput.displayName = "FocusSafeInput";

export default FocusSafeInput;
